var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8122 17.0624C39.3159 17.5687 39.038 18.2494 39.038 18.9583C39.038 19.6672 39.3159 20.3478 39.8122 20.8541L44.1455 25.1874C44.6518 25.6837 45.3324 25.9616 46.0413 25.9616C46.7503 25.9616 47.4309 25.6837 47.9372 25.1874L58.1476 14.977C59.5094 17.9865 59.9218 21.3395 59.3297 24.5893C58.7375 27.839 57.1691 30.8312 54.8333 33.1669C52.4976 35.5027 49.5054 37.0711 46.2557 37.6633C43.0059 38.2554 39.6529 37.843 36.6434 36.4812L17.9288 55.1958C16.8514 56.2732 15.3901 56.8785 13.8663 56.8785C12.3426 56.8785 10.8813 56.2732 9.80384 55.1958C8.72639 54.1183 8.12109 52.657 8.12109 51.1333C8.12109 49.6095 8.72639 48.1482 9.80384 47.0708L28.5184 28.3562C27.1566 25.3467 26.7442 21.9937 27.3363 18.7439C27.9285 15.4942 29.4969 12.502 31.8327 10.1663C34.1684 7.83051 37.1606 6.26206 40.4103 5.66995C43.6601 5.07783 47.0131 5.49017 50.0226 6.85202L39.8122 17.0624Z",
    stroke: "#F5F5F5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolBg);
export default __webpack_public_path__ + "static/media/ToolBG.241453e0f7c291d1d8757535848f035e.svg";
export { ForwardRef as ReactComponent };